import type { BackendUpdateErrorResponse } from '@freelancer/datastore';
import type {
  MembershipDowngradesCollection,
  MembershipPackagesCollection,
  MembershipSubscriptionHistoryCollection,
} from '@freelancer/datastore/collections';

export enum CancelFlowStep {
  INFO = 1,
  FEEDBACK = 2,
  FINAL = 3,
}

export interface CancelFlowResponse {
  readonly currentStep: CancelFlowStep;
  readonly response: BackendUpdateErrorResponse<
    | MembershipSubscriptionHistoryCollection
    | MembershipPackagesCollection
    | MembershipDowngradesCollection
  >;
}

export enum BillingStatus {
  CANCELLED = 'cancelled',
  CONTRACT_DOWNGRADED = 'contract_downgraded',
  DOWNGRADED = 'downgraded',
  RENEWAL = 'renewal',
}

export enum SubscriptionType {
  CONTRACT = 'contract',
  PAID = 'paid',
  TRIAL = 'trial',
}

export enum UserType {
  EARNING_FREELANCER = 'earning_freelancer',
  EMPLOYER = 'employer',
  NEW_FREELANCER = 'new_freelancer',
  NON_EARNING_FREELANCER = 'non_earning_freelancer',
}

export const EMPLOYER_BENEFITS: readonly string[] = [
  'free_extend',
  'free_hidden_bids',
  'free_non_disclosure_agreement',
  'freelancer_reward',
];

export const FREELANCER_BENEFITS: readonly string[] = [
  'bids_limit',
  'skills_limit',
  'same_day_withdrawal',
  'preferred_freelancer',
];

export const MEMBERSHIP_SETTINGS_PROMO_REF = 'profile_setting_promo';
export const MEMBERSHIP_SETTINGS_REF = 'profile_setting';
export const TEAM_PACKAGE_CATEGORY_ID = 7;
